import Label from 'Components/Label';
import { useEffect, useRef, useState } from 'react';
import moment from 'moment';
import Button from 'Components/Button';
import OrdenPagoService from 'Services/Http/OrdePago.service';
import Paginador from 'Components/Paginador';
import ProgressBar from 'Components/ProgressBar';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setOdp } from '../../../../../redux/slices';

const ListarOrdenPagoComponente = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [otps, setOtps] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState(null);
  const [disabledFile, setDisabledFile] = useState(true);
  const [loader, setLoader] = useState(false);
  const [loaderFile, setLoaderFile] = useState(false);
  const [pageActive, setPageActive] = useState(0);

  const StatusOdpEnum = {
    SinEnviar: 0,
    Notificado: 1,
    Enviada: 2,
    Entregada: 3
  };

  useEffect(() => {
    getlastOtps();
  }, []);

  const getlastOtps = async (page) => {
    setLoader(true);
    try {
      setOtps([]);
      setPageActive(page);
      const response = await OrdenPagoService.orders({ page });
      createRows(response.data);
      setLoader(false);
    } catch (e) {
      console.log(e);
      setLoader(false);
    }
  };

  const inputFile = useRef(null);
  const onFileChange = (event) => {
    setSelectedFiles(event.target.files[0]);
    setDisabledFile(false);
  };

  const onFileUpload = async () => {
    setLoaderFile(true);
    try {
      const formData = new FormData();
      formData.append('images', selectedFiles, selectedFiles.name);
      await OrdenPagoService.documentos(formData);
      setLoaderFile(false);
    } catch (e) {
      console.log(e);
      setLoaderFile(false);
    }
  };
  const refresh = () => {
    getlastOtps(pageActive);
  };

  const asiganarODP = (item) => {
    dispatch(setOdp(item));
    const url = `/main/admin/ordenpago/${item.id}/asignar`;
    goTo(url);
  };

  const goTo = (url) => {
    navigate(url);
  };

  const openImage = (link, name) => {
    window.open(link, name, 'popup');
  };

  const getStateValue = (label) => {
    let text = '';
    console.log(StatusOdpEnum.SinEnviar, label);
    switch (label) {
      case StatusOdpEnum.SinEnviar:
        text = 'Sin Enviar';
        break;
      case StatusOdpEnum.Notificado:
        text = 'Notificado';
        break;
      case StatusOdpEnum.Entregada:
        text = 'Entregada';
        break;
      case StatusOdpEnum.Enviada:
        text = 'Enviada';
        break;
      default:
        text = label;
        break;
    }
    return text;
  };

  const createRows = (rows) => {
    let data = rows.map((item, index) => {
      const state = getStateValue(item.aplicada);
      return (
        <tr
          key={'otps-row-' + index}
          className="odd:bg-white even:bg-blue-100 border-b hover:bg-blue-300 hover:cursor-pointer">
          <td className="px-6 py-4">{index + 1}</td>
          <td className="px-6 py-4">{item.origen}</td>
          <td className="px-6 py-4">
            <Button
              iconprefix={['fa', 'fa-file-invoice-dollar']}
              onClick={() => openImage(item.linkOdpImage, item.nombreCliente)}
              loading={loader}
            />
          </td>
          <td className="px-6 py-4">{item.pagina}</td>
          <td className="px-6 py-4">{item.nombreCliente}</td>
          <td className="px-6 py-4">{item.monto}</td>
          <td className="px-6 py-4">{state}</td>
          <td className="px-6 py-4">
            {item.idCredito ? (
              `MR${item.idCredito}`
            ) : (
              <Button label="Asignar" onClick={() => asiganarODP(item)} />
            )}
          </td>
          <td className="px-6 py-4">
            {moment(item.created_at).utc().format('DD/MM/YYYY hh:mm:ss a')}
          </td>
        </tr>
      );
    });
    setOtps(data);
  };
  return (
    <>
      <Label text={'Lista ordenes de pago'} />
      <div className="flex flex-col grid grid-cols-1 md:grid md:grid-flow-col md:grid-cols-2 md:flex-row gap-3 my-3 justify-stretch">
        <div className="flex order-2 md:order-1">
          <input type="file" ref={inputFile} onChange={onFileChange} hidden />
          <Button iconprefix={['fa', 'rotate']} onClick={() => refresh()} />
          <Button iconprefix={['fa', 'file']} onClick={() => inputFile.current.click()} />
          <Button
            label="Subir"
            onClick={onFileUpload}
            disabled={disabledFile}
            loading={loaderFile}
          />
        </div>
      </div>
      <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
        <table className="w-full text-sm text-left rtl:text-right text-black">
          <thead className="text-xs text-white uppercase bg-blue-500">
            <tr>
              <th scope="col" className="px-6 py-3">
                #
              </th>
              <th scope="col" className="px-6 py-3">
                Archivo
              </th>
              <th scope="col" className="px-6 py-3">
                Image
              </th>
              <th scope="col" className="px-6 py-3">
                Pagina
              </th>
              <th scope="col" className="px-6 py-3">
                Nombre cliente
              </th>
              <th scope="col" className="px-6 py-3">
                Monto
              </th>
              <th scope="col" className="px-6 py-3">
                Enviada
              </th>
              <th scope="col" className="px-6 py-3">
                Credito
              </th>
              <th scope="col" className="px-6 py-3">
                Fecha y hora
              </th>
            </tr>
          </thead>
          <tbody>{otps}</tbody>
          <tfoot>
            <tr>
              <td colSpan={8}>
                <Paginador onChange={getlastOtps} />
              </td>
            </tr>
          </tfoot>
        </table>
        {loader ? <ProgressBar /> : ''}
      </div>
    </>
  );
};

export default ListarOrdenPagoComponente;
